import React, {useLayoutEffect, useRef, useState} from 'react';

import {cls} from '../../utils';

import css from './collapse.module.css';

type Props = {
	open: boolean;
	className?: string;
	/** обёртка вокруг раскрывающегося блока, например строка таблицы: существует, только пока блок в документе */
	wrapper?: (content: React.ReactNode) => React.ReactNode;
	children: React.ReactNode;
};

/** плавно раскрывает и сворачивает содержимое по высоте; свёрнутое содержимое убирается из документа */
export const Collapse: React.FC<Props> = ({open, className, wrapper, children}) => {
	const [isMounted, setMounted] = useState(open);
	const [isExpanded, setExpanded] = useState(open);
	const ref = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (!open) {
			setExpanded(false);
			return;
		}
		if (!isMounted) {
			setMounted(true);
			return;
		}
		/* чтение размера фиксирует свёрнутое состояние: от него начинается переход */
		void ref.current?.offsetHeight;
		setExpanded(true);
	}, [open, isMounted]);

	if (!isMounted) return null;

	const content = (
		<div
			ref={ref}
			className={cls(css.collapse, isExpanded && css.expanded, className)}
			onTransitionEnd={(event) => {
				if (event.target === event.currentTarget && !open) setMounted(false);
			}}
		>
			<div className={css.content}>{children}</div>
		</div>
	);
	return <>{wrapper ? wrapper(content) : content}</>;
};
